export { default } from './TAGTabs';